import script from "./ModalStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalStatus.vue?vue&type=script&setup=true&lang=js"

import "./ModalStatus.vue?vue&type=style&index=0&id=8368f38c&lang=css"

const __exports__ = script;

export default __exports__